import styled from 'styled-components'
import { Spinner as BaseSpinner } from 'Components/common/Spinner'

export const ExternalViewerContainer = styled.div`
  min-height: 100vh;
  background: white;
`

export const ProtectedHero = styled.div`
  background: linear-gradient(135deg, var(--vo-escuro) 0%, var(--vo-escuro-2) 100%);
  padding: 40px 24px 32px;
  text-align: center;
`

export const ProtectedHeroInner = styled.div`
  max-width: 640px;
  margin: 0 auto;
`

export const ProtectedHeroLabel = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-bottom: 8px;
`

export const ProtectedHeroLabelText = styled.span`
  font-family: 'Maven Pro', sans-serif;
  font-size: 12px;
  font-weight: 600;
  color: color-mix(in srgb, var(--vo-white) 60%, transparent);
  text-transform: uppercase;
  letter-spacing: .1em;
`

export const ProtectedHeroTitle = styled.h1`
  font-family: 'Rubik', sans-serif;
  font-size: 26px;
  font-weight: 800;
  color: white;
  margin: 0 0 6px;
  letter-spacing: -.02em;
`

export const ProtectedHeroCaption = styled.p`
  font-family: 'Maven Pro', sans-serif;
  font-size: 12px;
  font-weight: 500;
  color: color-mix(in srgb, var(--vo-white) 50%, transparent);
  margin: 0;
`

export const ExternalContent = styled.div`
  max-width: 1000px;
  margin: 0 auto;
  padding: 0 24px 80px;
`

export const PillTabBar = styled.div`
  display: flex;
  gap: 4px;
  margin: 24px 0;
  background: white;
  border-radius: 12px;
  padding: 5px;
  box-shadow: 0 1px 3px var(--vo-escuro-8);
  width: fit-content;
`

export const PillTab = styled.button`
  height: 36px;
  padding: 0 16px;
  border: none;
  border-radius: 9px;
  background: ${({ $active }) => $active ? 'var(--vo-celeste)' : 'transparent'};
  color: ${({ $active }) => $active ? 'white' : 'var(--vo-slate)'};
  font-family: 'Maven Pro', sans-serif;
  font-size: 13px;
  font-weight: ${({ $active }) => $active ? '600' : '500'};
  cursor: pointer;
  white-space: nowrap;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background .15s, color .15s;
  &:hover:not([data-active="true"]) {
    background: var(--vo-mist);
    color: var(--vo-ink-2);
  }
`

export const TabContent = styled.div`
  padding: 0;
`

export const TabBar = styled.div`
  border-bottom: 1px solid var(--vo-cloud);
  margin-bottom: 24px;
`

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 50vh;
`

export const ErrorContainer = styled.div`
  text-align: center;
  padding: 80px 0;
`

export const ErrorTitle = styled.h3`
  font-size: 24px;
  margin: 0 0 16px 0;
  color: var(--vo-slate);
  font-weight: 400;
`

export const ErrorMessage = styled.p`
  font-size: 14px;
  margin: 0;
  color: var(--vo-slate);
`

export const Spinner = styled(BaseSpinner)``

export const SmallSpinner = styled(BaseSpinner)`
  width: 24px;
  height: 24px;
  border-width: 2px;
`

export const ExternalViewerHeading = styled.h1`
  font-size: 34px;
  font-weight: 600;
  margin: 0 0 8px 0;
  color: var(--vo-ink);
`

export const DetailPanel = styled.div`
  background: white;
  border: 1px solid var(--vo-cloud);
  border-radius: var(--radius-lg);
  padding: 24px;
  margin-bottom: 16px;
`
